import React from 'react';
import SMOwnerListSummaryView from './SMOwnerListSummaryView';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMRestClient from 'lib/SMRestClient';
import sprintf from 'sprintf';
import OptimizedImage from 'components/shared/OptimizedImage';

class SMOwnerView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    // $('img.cld-hidpi').cloudinary_update();
  }

  render() {

    const owner = this.props.owner;
    let rows = [];
    this.props.spaces.forEach((space)=>{
      let image = null;
      const imageUrl = SMFormatHelper.imageURLWithTransform(space.thumbnails[0].image,{width: 840, height: 560, crop: 'fill', background: '#9c9c9c'});
      if (space.thumbnails.length > 0) {
        image = <OptimizedImage src={imageUrl} alt={sprintf("%s の写真", space.name)} className="units-item__image-pict is-hover" />;
      }
      rows.push(
        <li key={space.id} className="col-sm-12 col-md-4 details__units-item__list">
          <div className="js-image-keep-aspect units-item__image">
            <a className="js-image-keep-aspect__image" href={Routes.space_path(space.username)}>{image}</a>
          </div>
          <div className="units-item__body">
            <div className="units-item__body-inner link__subcolor">
              <h3 className="units-item__body-title"><a href={Routes.space_path(space.username)}>{space.name}</a></h3>
              <ul className="units-item__body-info">
                <li><i className="fa fa-map-marker mr5"></i><a href={Routes.search_index_path({location: space.state})}>{space.state_text}</a></li>
                <li>
                  <a href={Routes.reputations_space_path(space.username)}>{SMRenderHelper.renderReviewStars(space.reputation_score)}</a>
                  <a href={Routes.reputations_space_path(space.username)}>{space.reputation_count}件</a>
                </li>
              </ul>
            </div>
              <p className="js-line-camp-1 units-item__body-access">{space.access}</p>
          </div>
        </li>
      );
    });

    return(
      <div className="site-main" itemScope itemType="http://schema.org/LodgingBusiness">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <SMOwnerListSummaryView owner={owner} />
              <div className="col-sm-12 col-md-8">
                <div className="mod-review">
                  <h2 className="page-subtitle">評価とレビュー</h2>
                  <ul className="mod-review__head" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                    <li className="mod-review__head-star">
                      <a href={Routes.reputations_owner_path(owner.username)}>{SMRenderHelper.renderReviewStars(owner.reputation_score)}</a>
                    </li>
                    <li className="mod-review__head-rating" itemProp="ratingValue">{owner.reputation_score}</li>
                    <li itemProp="reviewCount">
                      <a href={Routes.reputations_owner_path(owner.username)} className="space-head__list-number">{owner.reputation_count}件</a>
                    </li>
                  </ul>
                  <SMReputationListView reputated="Owner" reputations={this.props.reputations} />
                  <div className="mod-more__link">
                    <a href={Routes.reputations_owner_path(owner.username)} className="button-blue pt13 pb13 w200">レビューをもっと見る</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page__odd page__padding">
          <div className="container">
            <h2 className="page-subtitle">会場一覧</h2>
            <div className="details__units-item">
              <ul className="row">
                {rows}
              </ul>
            </div>
            <SMSearchPagerView
              delegate={this}
              perPage={this.props.perPage}
              totalCount={this.props.totalCount}
              currentPage={this.props.currentPage}
              options={{className: "details__main-nav ta-c"}}
              links={SMRestClient.parseLinkString(this.props.linkString)} />
          </div>
        </div>
      </div>
    );
  }

}
export default SMOwnerView;



// WEBPACK FOOTER //
// ./app/javascript/components/owners/SMOwnerView.jsx